/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Create_Account_EmailInputs */

const th_admin_create_account_email = /** @type {(inputs: Admin_Create_Account_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อีเมล`)
};

const en_admin_create_account_email = /** @type {(inputs: Admin_Create_Account_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email address`)
};

const ja_admin_create_account_email = /** @type {(inputs: Admin_Create_Account_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールアドレス`)
};

const zh_admin_create_account_email = /** @type {(inputs: Admin_Create_Account_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`电子邮箱`)
};

const es_admin_create_account_email = /** @type {(inputs: Admin_Create_Account_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dirección de correo`)
};

const pt_admin_create_account_email = /** @type {(inputs: Admin_Create_Account_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endereço de e-mail`)
};

const id_admin_create_account_email = /** @type {(inputs: Admin_Create_Account_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alamat email`)
};

const fr_admin_create_account_email = /** @type {(inputs: Admin_Create_Account_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresse e-mail`)
};

const tl_admin_create_account_email = /** @type {(inputs: Admin_Create_Account_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email address`)
};

const vi_admin_create_account_email = /** @type {(inputs: Admin_Create_Account_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Địa chỉ email`)
};

const ko_admin_create_account_email = /** @type {(inputs: Admin_Create_Account_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이메일 주소`)
};

const de_admin_create_account_email = /** @type {(inputs: Admin_Create_Account_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail-Adresse`)
};

const ru_admin_create_account_email = /** @type {(inputs: Admin_Create_Account_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Адрес электронной почты`)
};

const tr_admin_create_account_email = /** @type {(inputs: Admin_Create_Account_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-posta adresi`)
};

const it_admin_create_account_email = /** @type {(inputs: Admin_Create_Account_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indirizzo email`)
};

const pl_admin_create_account_email = /** @type {(inputs: Admin_Create_Account_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adres e-mail`)
};

const uk_admin_create_account_email = /** @type {(inputs: Admin_Create_Account_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Адреса електронної пошти`)
};

const hi_admin_create_account_email = /** @type {(inputs: Admin_Create_Account_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ईमेल पता`)
};

const ar_admin_create_account_email = /** @type {(inputs: Admin_Create_Account_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البريد الإلكتروني`)
};

const ms_admin_create_account_email = /** @type {(inputs: Admin_Create_Account_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alamat e-mel`)
};

const bn_admin_create_account_email = /** @type {(inputs: Admin_Create_Account_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ইমেল ঠিকানা`)
};

const zh_tw2_admin_create_account_email = /** @type {(inputs: Admin_Create_Account_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`電子郵件`)
};

const zh_hk2_admin_create_account_email = /** @type {(inputs: Admin_Create_Account_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`電子郵件`)
};

const ur_admin_create_account_email = /** @type {(inputs: Admin_Create_Account_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ای میل پتہ`)
};

const fa_admin_create_account_email = /** @type {(inputs: Admin_Create_Account_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نشانی ایمیل`)
};

const sw_admin_create_account_email = /** @type {(inputs: Admin_Create_Account_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anwani ya barua pepe`)
};

const nl_admin_create_account_email = /** @type {(inputs: Admin_Create_Account_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mailadres`)
};

/**
* | output |
* | --- |
* | "Email address" |
*
* @param {Admin_Create_Account_EmailInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const admin_create_account_email = /** @type {((inputs?: Admin_Create_Account_EmailInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Create_Account_EmailInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_admin_create_account_email(inputs)
	if (locale === "ja") return ja_admin_create_account_email(inputs)
	if (locale === "zh") return zh_admin_create_account_email(inputs)
	if (locale === "es") return es_admin_create_account_email(inputs)
	if (locale === "pt") return pt_admin_create_account_email(inputs)
	if (locale === "id") return id_admin_create_account_email(inputs)
	if (locale === "fr") return fr_admin_create_account_email(inputs)
	if (locale === "tl") return tl_admin_create_account_email(inputs)
	if (locale === "vi") return vi_admin_create_account_email(inputs)
	if (locale === "ko") return ko_admin_create_account_email(inputs)
	if (locale === "de") return de_admin_create_account_email(inputs)
	if (locale === "ru") return ru_admin_create_account_email(inputs)
	if (locale === "tr") return tr_admin_create_account_email(inputs)
	if (locale === "it") return it_admin_create_account_email(inputs)
	if (locale === "pl") return pl_admin_create_account_email(inputs)
	if (locale === "uk") return uk_admin_create_account_email(inputs)
	if (locale === "hi") return hi_admin_create_account_email(inputs)
	if (locale === "ar") return ar_admin_create_account_email(inputs)
	if (locale === "ms") return ms_admin_create_account_email(inputs)
	if (locale === "bn") return bn_admin_create_account_email(inputs)
	if (locale === "zh-TW") return zh_tw2_admin_create_account_email(inputs)
	if (locale === "zh-HK") return zh_hk2_admin_create_account_email(inputs)
	if (locale === "ur") return ur_admin_create_account_email(inputs)
	if (locale === "fa") return fa_admin_create_account_email(inputs)
	if (locale === "sw") return sw_admin_create_account_email(inputs)
	if (locale === "nl") return nl_admin_create_account_email(inputs)
	return en_admin_create_account_email(inputs)
});